import * as React from "react";
import Box from "@mui/material/Box";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import { Control, useController } from "react-hook-form";
import TextField from "@mui/material/TextField";
import { PatientFormValues } from "../patient-form.component";

type MiddleNameFieldProps = {
  control: Control<PatientFormValues, object>;
};

export default function MiddleNameField({ control }: MiddleNameFieldProps) {
  const {
    field,
    formState: { errors },
  } = useController({
    name: "middle_name",
    control,
    rules: {
      pattern: {
        value: /^[a-z ,.'-]+$/i,
        message: "Middle Name is not valid.",
      },
    },
  });
  return (
    <Box display="flex" justifyContent="space-between">
      <PersonOutlineOutlinedIcon sx={{ mt: "30px", mr: 1.5 }} />
      <TextField
        fullWidth
        label="Middle Name"
        {...(Boolean(errors?.middle_name?.message)
          ? { error: true, helperText: errors?.middle_name?.message }
          : {})}
        {...field}
      />
    </Box>
  );
}
